import React, { useState, useEffect } from "react";
import "./StudentDirectory.css";
import {
  FaGraduationCap, // Fixed: Replaced FaUserGraduation with FaGraduationCap
  FaArrowLeft,
  FaSearch,
  FaFilter,
  FaPhoneAlt,
  FaNotesMedical,
  FaBirthdayCake,
  FaUserCircle,
} from "react-icons/fa";

const StudentDirectory = ({ token, onBack }) => {
  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProgram, setSelectedProgram] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulated fetch for student records
    // Replace with: apiService.getStudents(token)
    const fetchStudents = async () => {
      try {
        setLoading(true);
        setTimeout(() => {
          const mockData = [
            {
              id: 1,
              firstName: "Aarav",
              lastName: "Sharma",
              program: "Nursery",
              dob: "2022-04-12",
              gender: "Boy",
              fatherName: "Rajesh Sharma",
              primaryPhone: "9876543210",
              medicalNotes: "Mild peanut allergy",
            },
            {
              id: 2,
              firstName: "Ananya",
              lastName: "Patel",
              program: "Playgroup",
              dob: "2023-01-15",
              gender: "Girl",
              fatherName: "Amit Patel",
              primaryPhone: "9123456789",
              medicalNotes: "None",
            },
            {
              id: 3,
              firstName: "Kabir",
              lastName: "Verma",
              program: "UKG",
              dob: "2020-08-22",
              gender: "Boy",
              fatherName: "Sanjay Verma",
              primaryPhone: "9988776655",
              medicalNotes: "Asthma inhaler required on sports days",
            },
            {
              id: 4,
              firstName: "Diya",
              lastName: "Iyer",
              program: "LKG",
              dob: "2021-11-05",
              gender: "Girl",
              fatherName: "Karthik Iyer",
              primaryPhone: "9445566778",
              medicalNotes: "None",
            },
          ];
          setStudents(mockData);
          setFilteredStudents(mockData);
          setLoading(false);
        }, 600);
      } catch (error) {
        console.error("Error fetching students:", error);
        setLoading(false);
      }
    };

    fetchStudents();
  }, [token]);

  // Handle Search and Filter logic
  useEffect(() => {
    let result = students;

    if (selectedProgram !== "All") {
      result = result.filter((s) => s.program === selectedProgram);
    }

    if (searchTerm.trim() !== "") {
      const term = searchTerm.toLowerCase();
      result = result.filter(
        (s) =>
          s.firstName.toLowerCase().includes(term) ||
          s.lastName.toLowerCase().includes(term) ||
          s.fatherName.toLowerCase().includes(term) ||
          s.primaryPhone.includes(term)
      );
    }

    setFilteredStudents(result);
  }, [searchTerm, selectedProgram, students]);

  if (loading) {
    return (
      <div className="directory-loading">
        <div className="spinner"></div>
        <p>Loading Student Directory...</p>
      </div>
    );
  }

  return (
    <div className="student-directory-container">
      {/* Header Bar */}
      <div className="directory-header">
        <div className="header-left">
          <button className="back-btn" onClick={onBack} type="button">
            <FaArrowLeft /> Back to Dashboard
          </button>
          <h2>
            <FaGraduationCap className="header-icon" /> Student Directory
          </h2>
        </div>
        <div className="student-count-badge">
          Total Enrolled: {filteredStudents.length}
        </div>
      </div>

      {/* Filter & Search Controls */}
      <div className="directory-controls">
        <div className="search-box">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search by student name, parent name, or mobile..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="filter-box">
          <FaFilter className="filter-icon" />
          <select
            value={selectedProgram}
            onChange={(e) => setSelectedProgram(e.target.value)}
          >
            <option value="All">All Programs / Grades</option>
            <option value="Playgroup">Playgroup</option>
            <option value="Nursery">Nursery</option>
            <option value="LKG">LKG</option>
            <option value="UKG">UKG</option>
            <option value="Daycare">Daycare</option>
          </select>
        </div>
      </div>

      {/* Student Cards Grid */}
      {filteredStudents.length === 0 ? (
        <div className="no-results">
          <p>No student records match your search criteria.</p>
        </div>
      ) : (
        <div className="students-grid">
          {filteredStudents.map((student) => (
            <div key={student.id} className="student-card">
              <div className="card-top">
                <div className="avatar-placeholder">
                  <FaUserCircle />
                </div>
                <div className="student-titles">
                  <h3>
                    {student.firstName} {student.lastName}
                  </h3>
                  <span className={`program-tag ${student.program.toLowerCase()}`}>
                    {student.program}
                  </span>
                </div>
              </div>

              <div className="card-details">
                <div className="detail-row">
                  <span className="label"><FaBirthdayCake /> DOB:</span>
                  <span className="value">{student.dob}</span>
                </div>
                <div className="detail-row">
                  <span className="label">Parent:</span>
                  <span className="value">{student.fatherName}</span>
                </div>
                <div className="detail-row">
                  <span className="label"><FaPhoneAlt /> Phone:</span>
                  <span className="value">{student.primaryPhone}</span>
                </div>
                <div className="detail-row medical">
                  <span className="label"><FaNotesMedical /> Medical:</span>
                  <span className="value medical-text">{student.medicalNotes}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StudentDirectory;